// src/design-system/FormModal.tsx
import type { FormEventHandler, ReactNode } from "react";

import { Button } from "./Button";
import { Modal } from "./Modal";

/** نافذة نموذج: حفظ/إلغاء موحّدان، ورسالة خطأ الخادم فوق الأزرار مباشرة. */
export function FormModal({
  open, title, onClose, onSubmit, submitLabel = "حفظ", submitting, error, children, width,
}: {
  open: boolean; title: string; onClose: () => void; onSubmit: FormEventHandler<HTMLFormElement>;
  submitLabel?: string; submitting?: boolean; error?: string | null; children: ReactNode; width?: number;
}) {
  return (
    <Modal open={open} title={title} onClose={onClose} width={width}>
      <form onSubmit={onSubmit} className="flex flex-col gap-4" noValidate>
        {children}
        {error && <div role="alert" className="text-[12.5px] text-bad">{error}</div>}
        <div className="flex justify-end gap-2.5 border-t border-line pt-3.5">
          <Button onClick={onClose}>إلغاء</Button>
          <Button type="submit" variant="gold" loading={submitting}>{submitLabel}</Button>
        </div>
      </form>
    </Modal>
  );
}
